<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>未结算汇总列表</h4>
      </div>
      <div class="c-flex c-flex-item">
        <span class="c_dark c_size_14">安装时间起止：</span>
        <el-date-picker
          v-model="searchDate"
          type="datetimerange"
          :picker-options="date.pickerOptions"
          start-placeholder="安装时间 起"
          end-placeholder="安装时间 止"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          :clearable="false"
          @change="
            fpi.page = 1;
            getData();
          "
          class="search-date"
        ></el-date-picker>
        <el-input
          class="c-m-l-10"
          placeholder="请输入师傅姓名/手机号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="osg.has('unSettleGather,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'regex:userName|string#or': searchValue,
                'regex:userPhone|string#or': searchValue,
                'gte:finishedTime|string#and': searchDate[0],
                'lte:finishedTime|string#and': searchDate[1],
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'unSettleGather',
                title: '未结算单据汇总列表'
              },
              { dynamic: true, preset: '0' }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索师傅姓名/手机"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="doSettle(scope.row)" size="mini" type="success">确认</el-button>
              <el-button @click="getSettleDetail(scope.row)" size="mini" type="primary">
                查看明细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" layout="total" :total="fpi.data.length"></el-pagination>
        <!-- 结算明细 -->
        <el-dialog
          title="结算明细"
          :visible.sync="settleDetail.show"
          :close-on-click-modal="false"
          width="1000px"
        >
          <el-table
            ref="settleDetail"
            :data="settleDetail.data"
            highlight-current-row
            border
            height="500px"
          >
            <c-table :fields="settleDetail.fields"></c-table>
          </el-table>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      name: 'unSettleGather',
      colName: 'unSettleGather',
      fpi: { data: [] },
      searchValue: '',
      searchDate: [],
      openDetail: false,
      formData: {},
      // 结算明细
      settleDetail: {
        fields: [],
        data: [],
        show: false
      },
      extFields: [],
      extField: {},
      options: {},
      // 上传
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields(this.colName, () => {
      this.osg.getFpi();
      let dateRange = this.date.dateRange({ type: 'thisMonth' });
      this.searchDate = [dateRange.startDate + ' 00:00:00', dateRange.endDate + ' 23:59:59'];
      this.getData();
    });
    this.osg.getFields('settleDetail', () => {}, null, 'settleDetail.fields');
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      this.searchDate = this.searchDate || [];
      this.osg.ajax(
        '/privatization/delijingcheng/settleQuery.do',
        {
          regexParam: this.searchValue,
          startTime: this.searchDate[0],
          endTime: this.searchDate[1]
        },
        res => {
          res.data = res.data.map(item => {
            item.exts = item.exts || {};
            return item;
          });
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table && this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        }
      );
    },
    doSettle(row) {
      this.osg.confirm('是否确认结算？', () => {
        this.osg.ajax(
          '/privatization/delijingcheng/settleAdd.do',
          { data: JSON.stringify(row) },
          () => {
            this.osg.toast('结算成功');
            this.getData();
          }
        );
      });
    },
    getSettleDetail(row) {
      this.searchDate = this.searchDate || [];
      this.osg.ajax(
        '/biz/extForm/queryByColName/settleDetail.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc',
          'is:settleState|integer#and': 0,
          'gte:finishedTime|string#and': this.searchDate[0],
          'lte:finishedTime|string#and': this.searchDate[1],
          'is:userId|string#and': row.userId
        },
        res => {
          this.settleDetail.data = res.data;
          this.settleDetail.show = true;
          this.$nextTick(() => {
            this.$refs.settleDetail && this.$refs.settleDetail.doLayout();
          });
        }
      );
    }
  }
};
</script>
